export default "__VITE_ASSET__ee7ad95c__"